<template>
  <div>
    <div class="header">
      <van-tabs v-model="activeName">
        <van-tab title="安卓" name="a">
          <div v-for="item in nite" :key="item.id">
            <div v-if="item.isImage">
              <img style="width: 100%" :src="item.content" />
            </div>
            <div v-else style="font-size: 25px">
              {{ item.content }}
            </div>
          </div>
        </van-tab>
        <van-tab title="苹果" name="b">
          <div v-for="item in vv" :key="item.id">
            <div v-if="item.isImage">
              <img style="width: 100%" :src="item.content" />
            </div>
            <div v-else style="font-size: 25px">
              {{ item.content }}
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
  import { android, ios } from "@/api/apn";
  export default {
    name: "Apn",
    data() {
      return {
        activeName: "a",
        nite: [],
        vv: [],
      };
    },
    created() {},
    mounted() {
      this.getApnAndroid();
      this.getApnIOS();
    },

    methods: {
      getApnAndroid() {
        android().then((res) => {
          if (res.status) {
            this.nite = res.data;
          }
        });
      },
      getApnIOS() {
        ios().then((res) => {
          if (res.status) {
            this.vv = res.data;
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    background-color: white;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
  }
  .detail {
    padding: 5px;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
  }
</style>
